var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.item.Blocked
        ? _c(
            "div",
            { staticClass: "sidebar-contact-blocked" },
            [
              _c("w-fa", {
                staticClass: "mr",
                attrs: { icon: "exclamation-triangle" },
              }),
              _vm._v(
                " " + _vm._s(_vm.$ct("sidebar.contact-details.blocked")) + " "
              ),
            ],
            1
          )
        : _vm._e(),
      _c("app-sidebar-key-value-list", { attrs: { rows: _vm.rows } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }